import axios from "axios";
const baseUrl = "/api/v1";

// This file specifically will be additional request for patients flow
export const patients = {
  assignPhysicianForOpinion: (id, phsyician) =>
    axios.put(`${baseUrl}/patients/${id}/opinion/${phsyician}`),
  deletePhysicianAssigned: (id, phsyician) =>
    axios.delete(`${baseUrl}/patients/${id}/opinion/${phsyician}`),
  patchPhysician: (id, payload) =>
    axios.patch(`${baseUrl}/patients/${id}`, payload),
  reactivate: (id) => axios.put(`${baseUrl}/patients/${id}/reactivate`),
  deactivate: (id) => axios.put(`${baseUrl}/patients/${id}/deactivate`),
  get: (id) => axios.get(`${baseUrl}/patients/${id}`),
};
